import axios, { AxiosResponse } from 'axios';
import { environment } from 'src/config/environment';

export const BaseAxios = axios.create({
  baseURL: environment.apiUrl,
});

export const RedirectServerAxios = axios.create({
  baseURL: environment.redirectServerApiUrl,
});

export const AuthorizedBaseAxios = axios.create({
  baseURL: environment.apiUrl,
});

export const flatten = <T>(a: AxiosResponse<T>) => a.data;

// ------------------- error handling
export interface Error<T = unknown> {
  data?: T;
  errorCode: string;
  message: string;
}

export interface ErrorResponse<T = unknown> {
  errors: Error<T>[];
}

// https://github.com/axios/axios#handling-errors
export const getErrorResponse = (error: unknown) => {
  if (!axios.isAxiosError(error)) {
    return {
      errors: [{ data: error, errorCode: '-1', message: 'unknown' }],
    };
  }

  if (error.response) {
    return error.response.data;
  }

  if (error.request) {
    return {
      errors: [
        {
          data: error.request,
          errorCode: '-1',
          message: 'Unexpected request',
        },
      ],
    };
  }
  return {
    errors: [
      {
        data: error.message,
        errorCode: '-1',
        message: 'internal',
      },
    ],
  };
};
